export interface PaintColor {
  readonly id: string
  readonly name: string
  readonly hex: string
}

export const PAINT_COLORS: readonly PaintColor[] = [
  { id: 'black', name: 'Black', hex: '#000000' },
  { id: 'white', name: 'White', hex: '#ffffff' },
  { id: 'red', name: 'Red', hex: '#e53935' },
  { id: 'orange', name: 'Orange', hex: '#fb8c00' },
  { id: 'yellow', name: 'Yellow', hex: '#fdd835' },
  { id: 'green', name: 'Green', hex: '#43a047' },
  { id: 'teal', name: 'Teal', hex: '#00acc1' },
  { id: 'blue', name: 'Blue', hex: '#1e88e5' },
  { id: 'purple', name: 'Purple', hex: '#8e24aa' },
  { id: 'pink', name: 'Pink', hex: '#ec407a' },
  { id: 'brown', name: 'Brown', hex: '#795548' },
  { id: 'gray', name: 'Gray', hex: '#9e9e9e' },
] as const

export const DEFAULT_COLOR: PaintColor = PAINT_COLORS[0]
